import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmailAssessmentComponent } from './email-assessment.component';

const routes: Routes = [
  {
    path: '',
    component: EmailAssessmentComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EmailAssessmentRoutingModule {}
